import React, { ReactElement } from 'react'
// Externals imports.
import { Radio } from '@material-ui/core'
import Label from '../Label'
// CSS imports. Commented out because of current build process.
// import './radioButton.scss'

/**
 * Component properties type.
 */
export type RadioButtonProps<> = {
    value: string | number
    isChecked: boolean
    onChange: (value: string) => void
    labelRight?: string
    // eslint-disable-next-line
    disabled?: boolean
}

/**
 * Radio button component.
 *
 * @param value Value that should be set if this radio button is clicked.
 * @param isChecked Whether it is checked.
 * @param onChange Change handler propagating identifier of checked radio button.
 * @param labelRight right label of the radio button.
 */
const RadioButton = ({ value, isChecked, onChange, labelRight }: RadioButtonProps): ReactElement => {
    /**
     * Handles change event of the radio button.
     * @param event Change event.
     */
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (onChange) {
            onChange(event.target.value)
        }
    }

    const radioButtonLabelClass = `${labelRight ? 'label-right' : 'label-left'} clickable-label`

    return (
        <div className='radio-button'>
            <div className='input'>
                <Radio disableRipple checked={isChecked} onChange={handleChange} value={value} />
            </div>
            {labelRight && (
                <Label customClass={radioButtonLabelClass} onClick={(): void => onChange(value as string)}>
                    {labelRight}{' '}
                </Label>
            )}
        </div>
    )
}

export default RadioButton
